import ProductContainer from "../../../../Components/Applications/Ecommerce/Product/ProductContainer"

const Product = () => {
  return (
    <ProductContainer/>
  )
}

export default Product